<ng-container [formGroup]="formGroup">
  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.foyrRestaurantId' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="restaurantId">
    <mat-error *ngIf="formGroup.get('restaurantId')?.errors && formGroup.get('restaurantId')?.touched">
      {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
